(function () {
  'use strict';

  /* Sticky header: measure height, solidify on scroll */
  var header = document.querySelector('[data-header]');
  function setHeaderHeight() {
    if (!header) return;
    document.documentElement.style.setProperty('--header-total', header.offsetHeight + 'px');
  }
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  setHeaderHeight();
  onScroll();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Mobile drawer */
  var drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      document.body.classList.toggle('drawer-open', drawer.open);
      setHeaderHeight();
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.open) { drawer.open = false; drawer.querySelector('summary').focus(); }
    });
  }

  /* FAQ: one open at a time */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    var items = acc.querySelectorAll('details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* Offer selector */
  document.querySelectorAll('[data-offers]').forEach(function (wrap) {
    var radios = wrap.querySelectorAll('.v-offer__radio');
    var idInput = wrap.querySelector('[data-offer-id]');
    var qtyInput = wrap.querySelector('[data-offer-qty]');
    var planInput = wrap.querySelector('[data-offer-plan]');
    var submit = wrap.querySelector('[data-offer-submit]');
    function apply(r) {
      radios.forEach(function (o) { o.closest('.v-offer').classList.toggle('is-checked', o === r); });
      if (idInput && r.dataset.variant) idInput.value = r.dataset.variant;
      if (qtyInput) qtyInput.value = r.dataset.qty || 1;
      if (planInput) {
        planInput.value = r.dataset.plan || '';
        planInput.disabled = !r.dataset.plan;
      }
      if (submit && !submit.disabled && r.dataset.cta) submit.textContent = r.dataset.cta;
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(r); });
    });
    var checked = wrap.querySelector('.v-offer__radio:checked') || radios[0];
    if (checked) { checked.checked = true; apply(checked); }
  });

  /* Offer form: add to Dawn's cart drawer without leaving the page (falls back to /cart) */
  document.querySelectorAll('.v-offer-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      form.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
        if (!el.value) el.disabled = true;
      });
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      var errorEl = form.parentNode.querySelector('[data-offer-error]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding...'; }
      if (errorEl) errorEl.hidden = true;
      var fd = new FormData(form);
      fd.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (errorEl) { errorEl.textContent = res.description || res.message || 'Could not add to cart. Please try again.'; errorEl.hidden = false; }
            return;
          }
          drawer.renderContents(res);
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label; }
        });
    });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    q.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) - 1);
    });
    q.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 0) + 1;
    });
  });

  /* Product gallery thumbs */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.dataset.thumb;
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.slide === i); });
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });
  });

  /* Theme editor: re-init header height when sections reload */
  document.addEventListener('shopify:section:load', function () {
    header = document.querySelector('[data-header]');
    setHeaderHeight();
    onScroll();
  });
})();
